export const getLatestPrivacyPolicy = state => state.latest_privacy_policy;
// export const getLatestPrivacyPolicyToAccept = state =>
//   state.latest_privacy_policy_to_accept;
